const selectFileAlreadyExist = state => state.upload.exists;

export default {selectFileAlreadyExist};